/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RansomwareRecoveryEdrVendorEnum } from './ransomwareRecoveryEdrVendorEnum';
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';
import { RansomwareRecoveryProvisionModeEnum } from './ransomwareRecoveryProvisionModeEnum';


export interface TenantRwrActivationDetails { 
    /**
     * The user who requested activation.
     */
    activation_requested_by?: string;
    /**
     * The timestamp when activation was requested.
     */
    activation_requested_ts?: Date;
    activation_status?: RansomwareRecoveryDeploymentStatesEnum;
    /**
     * The task ID for the activation request.
     */
    activation_task_id?: string;
    /**
     * The user who requested deactivation.
     */
    deactivation_requested_by?: string;
    /**
     * The timestamp when deactivation was requested.
     */
    deactivation_requested_ts?: Date;
    /**
     * The task ID for the deactivation request.
     */
    deactivation_task_id?: string;
    /**
     * The organization ID for the EDR service.
     */
    edr_org_id?: string;
    /**
     * The region for the EDR cloud instance.
     */
    edr_region?: string;
    edr_vendor?: RansomwareRecoveryEdrVendorEnum;
    provision_mode?: RansomwareRecoveryProvisionModeEnum;
    /**
     * The ID for the ransomware recovery deployment.
     */
    ransomware_recovery_deployment_id?: string;
    /**
     * The organization ID for the vLCR provider.
     */
    vlcr_org_id?: string;
    /**
     * The cloud provider for the vLCR service.
     */
    vlcr_cloud_provider?: string;
    /**
     * The region for the vLCR service.
     */
    vlcr_region?: string;
}
export namespace TenantRwrActivationDetails {
}


